import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ISystemState } from '../../state/system.state';

export const getSystemState = createFeatureSelector<ISystemState>('system');

export const isLoading = createSelector(
    getSystemState,
    (state: ISystemState) => state.loading
);

export const getSystemStatus = createSelector(
    getSystemState,
    (state: ISystemState) => state.status
);
